import React from 'react'

import { NoData } from 'styles/shared'

import { deviceTypeDisplayName } from 'helpers/formatters'

import styled from 'styled-components'

type Props = {
  deviceType: string
  deviceModel: string
}

const OptedOut = ({ deviceType, deviceModel }:Props) => (
  <S.Container>
    <S.NoData>
      <h1>OPTED OUT</h1>
      <h2>This {deviceTypeDisplayName(deviceType)} cannot be displayed because it's OPTED OUT.</h2>
    </S.NoData>

    <S.Explanation>Customers must opt in for data to be visible. To direct your customer to opt in, they must:</S.Explanation>

    <S.Instructions>
      {deviceModel === 'Pivot'
        ? (
          <>
            <li>In Trane Pivot app or <a target="_blank" href="http://www.pivot.trane.com/" rel="noreferrer">www.pivot.trane.com</a>, ask the customer to click on "App Settings" in the left hand side navigation menu.</li>
            <li>Then, they can click the switch button at the top labeled “Enable Service Contractor to see information about your Thermostats”.</li>
          </>
        ) : (
          <>
            <li>In Trane® Home, click "edit" under the picture of their house.</li>
            <li>Next, click the checkbox labeled "Enable my HVAC Dealer to see diagnostic information about my HVAC system, as well as my name and home address".</li>
            <li>Finally, click the "Save Changes" button.</li>
          </>
        )
      }
    </S.Instructions>

    <S.ImgContainer>
      <S.InstructionsImg
        src={deviceModel === 'Pivot' ? '/img/devices/enable_commercial.png' : '/img/devices/enable_diagnostics_trane_home.png'}
        alt="opted-out-instructions"
      />
    </S.ImgContainer>
  </S.Container>
)

export default OptedOut

const S = {
  Container: styled.div`
    padding: 0 10px 0;
  `,
  NoData: styled(NoData)`
    padding: 6em 0 6em 0;
  `,
  Explanation: styled.div`
    text-align: center;
    margin: 0 auto 20px;
    font-weight: 600;
  `,
  Instructions: styled.ol`
    max-width: 500px;
    margin: 0 auto 30px;
    font-size: 12px;
    list-style-type: decimal;
  `,
  ImgContainer: styled.div`
    margin: 0 auto;
    justify-content: center;
    max-height: 837px;
    max-width: 1023px;
  `,
  InstructionsImg: styled.img`
    max-width: 100%;
    height: auto;
    background-size: contain;
  `
}
